export default "__VITE_ASSET__CoFCDA9x__"